export * from "./debounce"
export const __HEADERS_URL__ =
  window.location.origin === "https://globalalliances.apps.realtor/"
    ? "https://narnav.apps.realtor"
    : "https://narnav-dev.apps.realtor"
